import api from 'networkapp-api-connector';

export default {
    fetchUserData: function (userId) {
        return api.users.fetchUserData(userId).then(function (user) {
            user.user_id = userId;
            app.store.dispatch(app.actions.users.updateUserData(user));
        });
    },
    updateUserProfile: function (userId, data) {
        return api.users.updateUserProfile(userId, data).then(function (user) {
            app.store.dispatch(app.actions.users.updateUserData(user));
            return user;
        });
    },
    changePassword: function (oldPassword, newPassword) {
        return api.users.changePassword(oldPassword, newPassword).then((user) => {
            // update session, since old sessions are invalidated
            app.store.dispatch(app.actions.session.login(user));
            return user;
        });
    },
    uploadPhoto: function (userId, file) {
        return api.users.uploadPhoto(userId, file).then(function () {
            // Refetch user data
            return app.api.users.fetchUserData(userId);
        });
    },
    deleteAccount: function () {
        let userId = _(app.store.getState()).get('session.user.id');
        return api.users.deleteAccount(userId).then(() => {
            app.store.dispatch(app.actions.session.logout());
            location.reload();
        });
    },
    registerDevice: function (subscription) {
        let userId = _(app.store.getState()).get('session.user.id');
        return api.users.registerDevice(userId, subscription);
    },
    unregisterDevice: function (wooshId) {
        let userId = _(app.store.getState()).get('session.user.id');
        if (!userId) return Promise.resolve();

        return api.users.unregisterDevice(userId, wooshId);
    },
};
